import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

const routes = []

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.query && to.query.lang) {
        if (to.query.lang === 'en' || to.query.lang === 'sl') {
            store.commit('setLanguage', to.query.lang);
        }
    }

    next();
});

export default router
